// app/javascript/controllers/tabs_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab"]

    connect() {
        this.bound = this.onFrameLoad.bind(this)
        document.addEventListener("turbo:frame-load", this.bound)
    }

    disconnect() {
        document.removeEventListener("turbo:frame-load", this.bound)
    }

    onFrameLoad(event) {
        const frame = event.target
        if (frame.id !== "party_tab") return

        // Use the URL’s trailing /:tab to decide which link to mark active
        const url = new URL(event.detail?.fetchResponse?.response?.url || window.location.href)
        const parts = url.pathname.split("/")
        const idx = parts.indexOf("tab")
        const tab = idx > -1 ? parts[idx + 1] : "details"

        this.tabTargets.forEach((el) => {
            const name = el.dataset.tabsName
            el.classList.toggle("active", name === tab)
        })
    }
}